import React, { useState, useEffect, useCallback } from "react";

import {
  Grid,
  InputLabel,
  OutlinedInput,
  Typography,
  ListItemText,
  FormControlLabel,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector, useDispatch } from "react-redux";
import MixChart from "./MixChart";

// import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
// import CircleIcon from "@mui/icons-material/Circle";

import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

import TopButton from "../../../Components/UI/TopButtons";
import Placeholder from "../../../Components/UI/Placeholder";

import { getFormatedDate, addDays, getDaysDiff } from "../../../Js/TimeAndDate";
import { joinByKeys, getClassNames } from "../../../Js/Common";
import {
  map,
  chain,
  groupBy,
  uniqBy,
  intersection,
  find,
  uniq,
  findIndex,
  sortBy,
  minBy,
  maxBy,
} from "lodash";
import { blue } from "@mui/material/colors";
import { getDataService } from "./Services";
import { getUsersByRoleId } from "../../Users/Services";

import { commonSliceActions } from "../../../Store/Slices/CommonSlice";

const daysMixSeries = [
  {
    name: "Ideal Progression",
    field: "defaultDays",
    type: "area",
  },
  {
    name: "Completion Days",
    field: "daysForAttemptAfterFirstLogin",
    type: "line",
  },
  // {
  //   name: "Attempt Days",
  //   field: "daysForAttemptAfterFirstLogin",
  //   type: "line",
  // },
];

const ProgressReport = () => {
  // Hooks
  const classes = useStyles();
  const dispatch = useDispatch();

  let DataFilter = [
    { id: "default", value: "Default" },
    { id: "full_report", value: "Full Report" },
  ];

  let [finalData, setFinalData] = useState([]);
  let [seriesMetaData, setSeriesMetaData] = useState(daysMixSeries);
  let [chartLabelField, setChartLabelField] = useState("title");
  let [selectedDataFilter, setSelectedDataFilter] = useState("default");

  let [allClasses, setAllClasses] = useState([]);
  let [selectedClassId, setSelectedClassId] = useState(null);

  let [learnerData, setLearnerData] = useState([]);
  let [selectedLearnerId, setSelectedLearnerId] = useState(null);

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const serverRole = useSelector((state) => state.defs.serverRole);
  const { loader } = useSelector((state) => state.common);

  useEffect(() => {
    let innerFun = async () => {
      if (userInfo) {
        if (userInfo.rolesInfo.title.toLowerCase() == "learner") {
          initialRender();
        } else {
          let allClassesData = await getClassNames(userInfo.site_uuid);
          setAllClasses(allClassesData);
        }
      }
    };
    innerFun();
  }, [userInfo, selectedDataFilter]);

  const initialRender = useCallback(
    async (actor = userInfo.uid) => {
      let userLogsData = await getDataService("learners-progress-report", {
        query: {
          actor: actor,
          site_uuid: userInfo.site_uuid,
        },
      });
      console.log(":S:S:S:S:userLogsData", userLogsData);
      let allAssignedAssignments = userLogsData.data.data.assignmentsData;

      let uniqAssignments = chain(userLogsData.data.data.userLogsData)
        // Group the elements of Array based on `color` property
        .groupBy("target")
        // `key` is group's name (color), `value` is the array of objects
        .map((value, key) => ({ target: key, data: value }))
        .value();

      let firstLoginRecord = await getDataService("user-logs", {
        query: {
          actor: actor,
          site_uuid: userInfo.site_uuid,
          verb: "login",
          $sort: {
            created_at: 1,
          },
          $limit: 1,
        },
      });
      let allTasks = [];
      allAssignedAssignments.forEach((val) => {
        allTasks = allTasks.concat(val["tasks"]["tasks"]);
      });

      let firstAttempts = uniqAssignments.map((val) => {
        let minIdRecord = minBy(val.data, "id");
        let maxIdRecord = maxBy(val.data, "id");
        return {
          attemptRecord: minIdRecord,
          completionRecord: maxIdRecord,
          daysForAttemptAfterFirstLogin: getDaysDiff(
            firstLoginRecord.data.data[0]["createdAt"],
            minIdRecord["created_at"]
          ),
          daysForCompletionAfterFirstLogin: getDaysDiff(
            firstLoginRecord.data.data[0]["createdAt"],
            maxIdRecord["created_at"]
          ),
        };
      });

      let allTaskData = await getDataService("tasks", {
        query: {
          uid: allTasks,
          site_uuid: userInfo.site_uuid,
          $limit: -1,
        },
      });

      let extraFiveCount = 0;
      let finalChartData = [];
      allAssignedAssignments = sortBy(allAssignedAssignments, [
        (o) => {
          return +o.title;
        },
      ]);
      allAssignedAssignments.forEach((val) => {
        let foundObj = find(allTaskData.data, {
          uid: val.tasks.tasks[0],
        });
        let defaultDays = find(foundObj["tags"]["tags"], (o) => {
          return !isNaN(o);
        });
        let foundLogData = find(uniqAssignments, { target: val.uid });
        if (foundLogData) {
          let minIdRecord = minBy(foundLogData.data, "id");
          let maxIdRecord = maxBy(foundLogData.data, "id");
          val = {
            ...val,
            attemptRecord: minIdRecord,
            completionRecord: maxIdRecord,
            daysForAttemptAfterFirstLogin: getDaysDiff(
              firstLoginRecord.data.data[0]["createdAt"],
              minIdRecord["created_at"]
            ),
            daysForCompletionAfterFirstLogin: getDaysDiff(
              firstLoginRecord.data.data[0]["createdAt"],
              maxIdRecord["created_at"]
            ),
          };
        } else {
          if (selectedDataFilter == "default") {
            extraFiveCount++;
          }
          val = {
            ...val,
            attemptRecord: {},
            completionRecord: {},
            daysForAttemptAfterFirstLogin: 0,
            daysForCompletionAfterFirstLogin: 0,
          };
        }
        if (selectedDataFilter == "default" && extraFiveCount < 6) {
          finalChartData.push({
            ...val,
            title: val.title,
            defaultDays: +defaultDays,
          });
        }
        if (selectedDataFilter == "full_report") {
          finalChartData.push({
            ...val,
            title: val.title,
            defaultDays: +defaultDays,
          });
        }
      });

      setFinalData(finalChartData);
    },
    [userInfo, selectedDataFilter, selectedLearnerId]
  );

  const handleClassChange = (itemData) => {
    resetState();
    setSelectedClassId(itemData.id);
    fetchUsersByRole(itemData.id);
  };

  const fetchUsersByRole = async (selectedClassId) => {
    let params = {
      query: {
        $select: ["uid", "name"],
        site_uuid: userInfo.site_uuid,
        belongs_to: selectedClassId,
        status: true,
        $limit: -1,
      },
    };

    let resUsersData = await getUsersByRoleId(params);
    console.log("res==>", resUsersData);
    setLearnerData(
      sortBy(resUsersData.data, [
        (o) => {
          return o.name.firstname;
        },
      ])
    );
  };

  const handleClassChange1 = (itemData) => {
    console.log("S:S:S:s", itemData.uid);
    setSelectedLearnerId(itemData.uid);
    initialRender(itemData.uid);
  };

  const resetState = () => {
    setSelectedClassId(null);
    setSelectedLearnerId(null);
    setLearnerData([]);
  };

  return (
    <>
      <Grid item xs={12} sx={{ px: 1 }}>
        <Grid
          container
          sx={{
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          {userInfo.rolesInfo.title.toLowerCase() != "learner" && (
            <>
              <Grid item sx={{ px: 1 }}>
                <FormControl sx={{ minWidth: 150 }} size="small">
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          px: 1,
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#DB8829",
                          "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                        }}
                      >
                        Select Classes
                      </Typography>
                    }
                  />
                  <Select
                    value={selectedClassId}
                    sx={{
                      borderRadius: 20,
                      borderColor: "#DB8829",
                      color: "#DB8829",
                      fontWeight: "500",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                        width: "20ch",
                        mt: 0.5,
                      },
                    }}
                  >
                    {allClasses.map((itemData, index) => {
                      return (
                        <MenuItem
                          sx={{
                            color: "#DB8829",
                            fontSize: "0.8rem",
                            fontWeight: "500",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.2rem",
                            },
                          }}
                          key={`${index}_Class`}
                          value={itemData.id}
                          onClick={() => {
                            handleClassChange(itemData);
                          }}
                        >
                          {itemData.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item sx={{ px: 1 }}>
                <FormControl sx={{ minWidth: 150 }} size="small">
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          px: 1,
                          fontSize: "0.8rem",
                          fontWeight: "500",
                          color: "#DB8829",
                          "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                        }}
                      >
                        Select Learner
                      </Typography>
                    }
                  />
                  <Select
                    value={selectedLearnerId}
                    sx={{
                      borderRadius: 20,
                      borderColor: "#DB8829",
                      color: "#DB8829",
                      fontWeight: "500",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.4rem",
                        width: "20ch",
                        mt: 0.5,
                      },
                    }}
                  >
                    {learnerData.map((itemData, index) => {
                      return (
                        <MenuItem
                          sx={{
                            color: "#DB8829",
                            fontSize: "0.8rem",
                            fontWeight: "500",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.2rem",
                            },
                          }}
                          key={`${index}_learnerId`}
                          value={itemData.uid}
                          onClick={() => {
                            handleClassChange1(itemData);
                          }}
                        >
                          {joinByKeys(
                            itemData.name,
                            ["firstname", "lastname"],
                            " "
                          )}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}
          <Grid item sx={{ px: 1 }}>
            <FormControl sx={{ m: 2, width: 150, minWidth: 150 }} size="small">
              <ListItemText
                primary={
                  <Typography
                    sx={{
                      px: 1,
                      fontSize: "0.8rem",
                      fontWeight: "500",
                      color: "#DB8829",
                      "@media (min-width: 1636px)": { fontSize: "1.4rem" },
                    }}
                  >
                    Data Filter
                  </Typography>
                }
              />
              <Select
                value={selectedDataFilter}
                sx={{
                  borderRadius: 5,
                  backgroundColor: "#FFFFFF",
                }}
              >
                {DataFilter.map((itemData, index) => {
                  return (
                    <MenuItem
                      sx={{
                        color: "#DB8829",
                        fontSize: "0.8rem",
                        fontWeight: "500",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.2rem",
                        },
                      }}
                      key={`filter_${index}`}
                      value={itemData.id}
                      onClick={() => {
                        setSelectedDataFilter(itemData.id);
                      }}
                    >
                      {itemData.value}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ px: 1 }}>
        {finalData.length > 0 && (
          <MixChart
            chartData={finalData}
            chartWidth={"95%"}
            chartHeight={"500px"}
            seriesMetaData={seriesMetaData}
            labelField={chartLabelField}
            axisLabels={{ y: "Days" }}
            maxTick={{
              y:
                finalData[finalData.length - 1].defaultDays < 10
                  ? finalData[finalData.length - 1].defaultDays
                  : finalData[finalData.length - 1].defaultDays +
                    (finalData[finalData.length - 1].defaultDays % 10),
            }}
          />
        )}
      </Grid>
    </>
  );
};

const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});
export default ProgressReport;
